import * as S from './Divider.styled'

export const Divider = ({ ...props }) => <S.Divider {...props} />

export default Divider
